import Skeleton from "react-loading-skeleton";

import { PaymentMethods } from "../../api/types";
import Button from "../ui/button/Button";
import ProgressBar from "../ui/progressBar/ProgressBar";
import Spinner from "../ui/spinner/Spinner";
import styles from "./Subscription.module.scss";

type PlanUsageProps = {
  handleProceedToCheckout: () => void;
  isStatusPending: boolean;
  isAwaitingActivation: boolean;
  isFetching: boolean;
  data: {
    currentPlan: string;
    payment_method: null | PaymentMethods;
    price: { value: string; interval: string };
    statusTitle: string;
    status: string;
    validUntil: string;
    progressData: {
      title: string;
      min: number;
      /** null means the cap is unlimited */
      max: number | null;
    }[];
  };
};

const PlanUsage = ({
  data,
  isStatusPending,
  isAwaitingActivation,
  isFetching,
  handleProceedToCheckout,
}: PlanUsageProps) => {
  return (
    <div>
      <div className={styles.planInfoBlock}>
        {isFetching ? (
          <Skeleton width={120} />
        ) : (
          <>
            <span className={styles.planTitle}>{data.currentPlan}</span>
            <span className={styles.planPrice}>
              <span className={styles.planTitle}>{data.price.value}</span>
              <span className={styles.priceInterval}>
                {` / ${data.price.interval}`}
              </span>
            </span>
          </>
        )}
        <div className={styles.planRow}>
          <span className={styles.greenBage}>
            {isFetching ? <Skeleton width={60} /> : data.statusTitle}
          </span>
          <span className={styles.date}>
            {isFetching ? <Skeleton width={100} /> : data.validUntil}
          </span>
          {isStatusPending &&
            !isFetching &&
            (isAwaitingActivation ? (
              <span className={styles.activatingStatus}>
                <Spinner size="1rem" />
                Activating subscription…
              </span>
            ) : (
              <Button onClick={handleProceedToCheckout}>
                Proceed to Checkout
              </Button>
            ))}
        </div>
      </div>
      <div className={styles.progressBar}>
        {isFetching
          ? Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className={styles.progressRow}>
                <div className={styles.progressTitle}>
                  <Skeleton width={120} />
                </div>
                <Skeleton height={12} width={200} />
              </div>
            ))
          : data.progressData.map((progress, index) => (
              <div key={index} className={styles.progressRow}>
                <div className={styles.progressTitle}>{progress.title}</div>
                <ProgressBar min={progress.min} max={progress.max} />
              </div>
            ))}
      </div>
    </div>
  );
};

export default PlanUsage;
